module.exports = __webpack_public_path__ + "static/media/charity-1.7dd64f4c.svg";